'use client';

import { SxProps, keyframes } from '@mui/material';

import { Breakpoints, PrimaryColors } from '@/common/theme/constants';

const marqueeAnimationHorizontal = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const marqueeAnimationVertical = keyframes`
  0% {
    transform: translateY(-50%);
  }
  100% {
    transform: translateY(0);
  }
`;

export const clubStatusWrapperStyles = (
  sx?: SxProps,
  textLocation?: 'horizontal' | 'vertical',
  fullWidth = true
): SxProps => ({
  overflow: 'hidden',
  position: 'relative',
  width: textLocation === 'vertical' ? '1.75rem' : fullWidth ? '100%' : '180px',
  height: textLocation === 'vertical' ? '100%' : 'auto',
  [`@media (max-width:${Breakpoints.md}px)`]: {
    width: textLocation === 'vertical' ? '1.35rem' : fullWidth ? '1.35rem' : '200px',
  },
  ...sx,
});

export const clubStatusAnimationWrapperStyles = (
  scrollDirection?: 'horizontal' | 'vertical'
): SxProps => ({
  display: 'flex',
  gap: '.5rem',
  whiteSpace: 'nowrap',
  animation: `${scrollDirection === 'vertical' ? marqueeAnimationVertical : marqueeAnimationHorizontal} 60s linear infinite`,
  width: 'fit-content',
  alignItems: 'baseline',
  flexDirection: scrollDirection === 'vertical' ? 'column' : 'row',
});

export const clubStatusCopyStyles = (
  sx?: SxProps,
  textLocation?: 'horizontal' | 'vertical'
): SxProps => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '.5rem',
  color: PrimaryColors.radical,
  fontWeight: '900',
  textTransform: 'uppercase',
  flexShrink: 0,
  writingMode: textLocation === 'vertical' ? 'sideways-lr' : 'horizontal-tb',
  ...sx,
});

export const clubStatusTextStyles = ({
  hideArrow,
  index,
}: {
  hideArrow?: boolean;
  index: number;
}) => ({
  fontWeight: hideArrow ? (index % 2 === 0 ? 900 : 400) : 900,
  [`@media (max-width:${Breakpoints.md}px)`]: {
    fontSize: '12px',
  },
});
